import { h } from 'preact'
import { Message } from '../../../../lib/intl/Message'
import { InfoHeading } from './shared'
import { Geografi } from '../../../domain'

type Props = {
  geografi: Geografi
}

export function KommunevalgIFylkeInfo({ geografi }: Props) {
  return (
    <section>
      <InfoHeading id="info-kommunevalg-i-fylke-tittel" />
      <Message id="info-kommunevalg-i-fylke-beskrivelse" values={{ fylke: geografi.navn }} />
    </section>
  )
}
